import { useId } from "react";

export function AndroidIcon({
  size,
  bodyColor = "#34A853",
}: {
  size: number;
  bodyColor?: string;
}) {
  const androidMaskId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
    >
      <mask
        id={androidMaskId}
        width="14"
        height="8"
        x="1"
        y="4"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path fill="#fff" d="M14.667 4H1.333v7.712h13.334V4Z" />
      </mask>
      <g mask={`url(#${androidMaskId})`}>
        <path
          fill={bodyColor}
          d="m14.63 11.42-.012-.08a7.177 7.177 0 0 0-.1-.493 6.156 6.156 0 0 0-.263-.825 6.15 6.15 0 0 0-.302-.661 6.926 6.926 0 0 0-.489-.79 7.145 7.145 0 0 0-.734-.861 5.28 5.28 0 0 0-.35-.32 6.526 6.526 0 0 0-.836-.61c.004-.004.004-.008.008-.012.133-.232.27-.46.404-.693.133-.224.262-.448.395-.677.093-.16.19-.324.282-.485a.454.454 0 0 0 .053-.12.59.59 0 0 0 .008-.344c-.008-.028-.016-.056-.028-.08a.459.459 0 0 0-.04-.077.56.56 0 0 0-.214-.208.612.612 0 0 0-.38-.084c-.032.004-.064.008-.092.016a.589.589 0 0 0-.372.28l-.282.485-.395.677c-.134.233-.27.461-.404.693-.016.024-.028.053-.044.077l-.06-.024a6.734 6.734 0 0 0-2.389-.433h-.069a6.765 6.765 0 0 0-2.138.368l-.23.085c-.012-.024-.028-.049-.04-.073-.133-.232-.27-.46-.404-.693-.133-.224-.262-.448-.395-.677-.093-.16-.19-.324-.282-.485a.607.607 0 0 0-.371-.28C4.032 4.008 4 4.004 3.972 4a.612.612 0 0 0-.38.084.624.624 0 0 0-.282.365.626.626 0 0 0 .06.464l.283.485c.133.225.262.449.395.677.134.233.27.461.404.693l.004.004c-.27.169-.529.353-.775.557a6.539 6.539 0 0 0-1.154 1.242 6.605 6.605 0 0 0-1.153 2.769l-.012.08a6.39 6.39 0 0 0-.04.292h13.333c0-.1-.012-.196-.025-.292Z"
        />
        <path
          fill="#202124"
          d="M11.467 9.877c.267-.176.307-.585.085-.91-.218-.328-.613-.448-.88-.272-.266.177-.306.585-.084.91.218.328.613.449.88.272Zm-6.043-.268c.218-.329.182-.733-.085-.91-.266-.176-.661-.056-.88.273-.217.328-.18.733.086.91.266.176.657.051.88-.273Z"
        />
      </g>
    </svg>
  );
}

export function ChromeIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#chrome-clip)">
        <path
          d="M12 16.498C14.4853 16.498 16.5 14.4833 16.5 11.998C16.5 9.5127 14.4853 7.49799 12 7.49799C9.51472 7.49799 7.5 9.5127 7.5 11.998C7.5 14.4833 9.51472 16.498 12 16.498Z"
          fill="white"
        />
        <path
          d="M12 7.50002H19.7929C19.0033 6.13179 17.8673 4.99558 16.4992 4.20564C15.1311 3.41571 13.5792 2.99989 11.9994 3C10.4196 3.00011 8.86775 3.41614 7.49978 4.20627C6.1318 4.9964 4.99597 6.13276 4.20648 7.5011L8.10296 14.25L8.10644 14.2491C7.71007 13.5656 7.5009 12.7897 7.50001 11.9995C7.49912 11.2094 7.70655 10.433 8.10139 9.74856C8.49622 9.06414 9.06451 8.49591 9.74897 8.10115C10.4334 7.70639 11.2099 7.49904 12 7.50002Z"
          fill="url(#chrome-grad-red)"
        />
        <path
          d="M12 15.5625C13.9675 15.5625 15.5625 13.9675 15.5625 12C15.5625 10.0325 13.9675 8.4375 12 8.4375C10.0325 8.4375 8.4375 10.0325 8.4375 12C8.4375 13.9675 10.0325 15.5625 12 15.5625Z"
          fill="#1A73E8"
        />
        <path
          d="M15.8967 14.2511L12.0003 21C13.58 21.0002 15.132 20.5845 16.5001 19.7947C17.8683 19.0048 19.0043 17.8687 19.7941 16.5006C20.5839 15.1324 20.9995 13.5804 20.9993 12.0006C20.999 10.4209 20.5828 8.86904 19.7925 7.50116H11.9996L11.9987 7.50465C12.7888 7.50312 13.5654 7.70993 14.2501 8.10423C14.9348 8.49852 15.5035 9.06637 15.8988 9.75052C16.2941 10.4347 16.5021 11.2109 16.5017 12.0011C16.5013 12.7912 16.2927 13.5673 15.8967 14.2511Z"
          fill="url(#chrome-grad-yellow)"
        />
        <path
          d="M8.10321 14.2512L4.20673 7.50226C3.41665 8.87026 3.00067 10.4222 3.00061 12.0019C3.00055 13.5817 3.41642 15.1336 4.20639 16.5017C4.99637 17.8697 6.13261 19.0057 7.50086 19.7953C8.86912 20.585 10.4212 21.0005 12.0009 21L15.8974 14.2511L15.8949 14.2485C15.5011 14.9336 14.9337 15.5027 14.2499 15.8985C13.566 16.2944 12.7899 16.5029 11.9998 16.5032C11.2097 16.5035 10.4334 16.2954 9.74931 15.9001C9.06521 15.5047 8.49743 14.9359 8.10321 14.2512Z"
          fill="url(#chrome-grad-green)"
        />
      </g>
      <defs>
        <linearGradient
          id="chrome-grad-red"
          x1="4.20648"
          y1="8.62502"
          x2="19.7929"
          y2="8.62502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D93025" />
          <stop offset="1" stopColor="#EA4335" />
        </linearGradient>
        <linearGradient
          id="chrome-grad-yellow"
          x1="10.7707"
          y1="20.8797"
          x2="18.564"
          y2="7.38138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC934" />
          <stop offset="1" stopColor="#FBBC04" />
        </linearGradient>
        <linearGradient
          id="chrome-grad-green"
          x1="12.9743"
          y1="20.4381"
          x2="5.18102"
          y2="6.93976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E8E3E" />
          <stop offset="1" stopColor="#34A853" />
        </linearGradient>
        <clipPath id="chrome-clip">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HightouchIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#ht-clip)">
        <path
          d="M10.8867 1.23748C10.8867 0.91863 11.1452 0.660156 11.464 0.660156H30.763C31.0819 0.660156 31.3403 0.918631 31.3403 1.23748V20.5364C31.3403 20.8553 31.0819 21.1138 30.763 21.1138H10.8867V1.23748Z"
          fill="#40E398"
        />
        <path
          d="M10.887 30.7628C10.887 31.0816 10.6285 31.3401 10.3096 31.3401L1.23748 31.3401C0.918631 31.3401 0.660156 31.0816 0.660156 30.7628L0.660157 21.6906C0.660157 21.3718 0.918632 21.1133 1.23748 21.1133L10.887 21.1133L10.887 30.7628Z"
          fill="#191A1C"
        />
      </g>
      <defs>
        <clipPath id="ht-clip">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
